import { useCallback } from 'react';
import type { CaseRegisterRow } from './workspaceRegisters';
import type { SafetyDashboardRow } from '../../services/reportsApi';

type SafetyCaseLike = {
  key: string;
  title: string;
  primaryRow: SafetyDashboardRow;
};

/**
 * Cases register row action: Open Safety Case. Activation UX is out of scope.
 */
export function useWorkspaceCaseRegisterActions(args: {
  findSafetyCaseForRegister: (caseKey: string) => SafetyCaseLike | null;
  openNewActivityDrawer: (row: SafetyDashboardRow) => void;
  openLiveCase: (row: SafetyDashboardRow) => void;
  loadDashboard: () => Promise<void> | void;
  setActionWorkflowId: (workflowId: string | null) => void;
  setError: (message: string | null) => void;
}): (row: CaseRegisterRow) => void {
  const { findSafetyCaseForRegister, openLiveCase } = args;

  return useCallback((row: CaseRegisterRow) => {
    const safetyCase = findSafetyCaseForRegister(row.id);
    if (!safetyCase) return;
    openLiveCase(safetyCase.primaryRow);
  }, [
    findSafetyCaseForRegister,
    openLiveCase,
  ]);
}
